export default __webpack_public_path__ + "static/media/Materials Science and Metallurgical Engineering.8373b9eb.pdf";